import { render, staticRenderFns } from "./MyBoxesModal.vue?vue&type=template&id=a47f5efe&scoped=true"
import script from "./MyBoxesModal.vue?vue&type=script&lang=js"
export * from "./MyBoxesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47f5efe",
  null
  
)

export default component.exports